import React from "react";
import { useNavigate } from "react-router-dom";
import { Cake } from "@mui/icons-material";

const GOLD = "#ffc000";
const PRIMARY = "#000c66";

export const BirthdayCTA = () => {
  const navigate = useNavigate();
  const goToBirthdays = () => navigate("/birthdays");

  return (
    <section
      style={{ position: "relative", overflow: "hidden", background: "#fff" }}
    >
      <img
        src="/hbdd.png"
        alt=""
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "top",
          opacity: 0.5,
          pointerEvents: "none",
        }}
      />

      <div
        onClick={goToBirthdays}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && goToBirthdays()}
        className="mx-auto px-4 py-16 md:py-24 cursor-pointer"
        style={{ maxWidth: 1100, position: "relative", zIndex: 1 }}
      >
        <div className="text-center flex flex-col items-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
            <p
              className="font-abel uppercase tracking-[0.4em] text-xs"
              style={{ color: GOLD }}
            >
              A Little Celebration
            </p>
            <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
          </div>

          <h2
            className="font-aref font-bold leading-tight"
            style={{
              color: PRIMARY,
              fontSize: "clamp(1.75rem, 3.5vw, 2.8rem)",
            }}
          >
            Get Your <span style={{ color: GOLD }}>Birthday Card</span>
          </h2>

          <p
            className="font-abel text-base md:text-lg mt-5 leading-relaxed mx-auto"
            style={{
              color: "#000",
              maxWidth: 440,
            }}
          >
            Download your birthday card here — enter your surname and phone
            number to get a personalised card made just for you, ready to save
            and share.
          </p>

          <button
            onClick={(e) => {
              e.stopPropagation();
              goToBirthdays();
            }}
            className="inline-flex items-center gap-2 font-abel font-bold uppercase tracking-widest text-sm px-10 py-4 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-2xl mt-8"
            style={{
              background: PRIMARY,
              color: GOLD,
              boxShadow: `0 8px 32px ${PRIMARY}33`,
            }}
          >
            <Cake style={{ fontSize: 18 }} />
            Download My Card
          </button>
        </div>
      </div>
    </section>
  );
};
